import {styledBox} from "../../../../themes/architecture/styled-box";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";


export interface IJackpotBetWidgetBgBoxProps {
    layout: JACKPOT_WIDGET_LAYOUT;
}

export const JackpotBetWidgetBgBox = styledBox('JackpotBetWidgetBgBox');
